// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressHasNoLivingPurpose_container__wNsim","businessTextContainer":"AddressHasNoLivingPurpose_businessTextContainer__cLHaA"};